import {useActions, useGetters, useMutators, useState} from './_default.js';
import {MAP_OBJECT_TYPE_GEOFENCE} from "@/js/constants";
import axios from "axios";

export default {
    namespaced: true,
    state: {
        ...useState(),
        mapObjectsLoadUrl: '/payload/paginated/map/geofence',
        listUrl: '/payload/paginated/sidebar/geofence',
        params: { grouped: 1 },
        name: MAP_OBJECT_TYPE_GEOFENCE,
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
        changeActive({ state}, data) {
            return new Promise((resolve, reject) => {
                return axios.put('/geofence/change-active', data).then((response) => {
                    resolve(response?.data);
                }).catch((error) => {
                    reject(error);
                })
            });
        },
    },
}